/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 * 
 * Serwis do obsługi uprawnień
 * symbole muszą być zgode z tymi znajdujacymi się w tabeli user_priviledge_default
 */


app.service('_$privileges', function($http, $q) {
	var settings = {}; 
        var wasinited=false;
	
	return {
            
                //return promise 
                checkRightInRouting:function(symbol){
                  
                  if (!wasinited){  
                    return this.init().then(function(){
                        
                     return  this.refresh();
                        
                    }.bind(this)).then(function(){
                        
                        return this.read(symbol)?true:$q.reject();

                    }.bind(this));  
                  }
                  else{
                      
                      
                      var defer=$q.defer();
                      
                      this.read(symbol)?defer.resolve():defer.reject();
                      
                      return  defer.promise;
                  }
                      
                },
            
		/*
		 * inicjowanie listy z symbolami uprawnień
		 */
		init: function(){
                    
                        
                    
			return $http.get('/administration/getprivileges/getall')
				.success(function(response){
					for(var i in response){
						settings[response[i].symbol] = {read: false, write: false};
					}
                                        
                                        
				});
		},
		/*
		 * odświerzanie uprawnień
		 */
		refresh: function(){
			return $http.get('/administration/getprivileges/get')
				.success(function(response){
					for(var i in response){
						settings[response[i].symbol].read = response[i].pivot.read==1;
						settings[response[i].symbol].write = response[i].pivot.write==1;
					}
                                        
                                        wasinited=true;
				});
		},
		/*
		 * sprawdzanie uprawnień do odczytu
		 */
		read: function(symbol){
			return settings[symbol].read;
		},
		/*
		 * sprawdzanie uprawnień do zapisu
		 */
		write: function(symbol){
			return settings[symbol].write;
		}
	};
});